import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import Moment from 'react-moment';
import { number } from 'prop-types';

const propTypes = {
  status: number.isRequired,
  uts: number,
};

const defaultProps = {
  status: 0,
};

const renderStatus = (status, uts) => {
  switch (status) {
    case 0:
      return <FormattedMessage id="payments.status.wait" defaultMessage="Wait" />;
    case 1:
      return (
        <Fragment>
          <FormattedMessage id="payments.status.payd" defaultMessage="Payd" />
          &nbsp;&mdash;{' '}
          <Moment format="DD MMM YY" unix>
            {uts}
          </Moment>
        </Fragment>
      );
    case 2:
      return (
        <Fragment>
          <FormattedMessage id="payments.status.canceled" defaultMessage="Canceled" />
          {uts > 0 && (
            <span>
              &nbsp;&mdash;{' '}
              <Moment format="DD MMM YY" unix>
                {uts}
              </Moment>
            </span>
          )}
        </Fragment>
      );
    case 3:
    case 5:
      return (
        <Fragment>
          <FormattedMessage id="payments.status.sended" defaultMessage="Sended" />
          &nbsp;&mdash;{' '}
          <Moment format="DD MMM YY" unix>
            {uts}
          </Moment>
        </Fragment>
      );
    case 4:
      return (
        <Fragment>
          <FormattedMessage id="payments.status.error" defaultMessage="Error" />
          &nbsp;&mdash;{' '}
        </Fragment>
      );
    default:
      return null;
  }
};

const PaymentsStatus = ({ status, uts }) => (
  <span className="payment-status">{renderStatus(status, uts)}</span>
);

PaymentsStatus.propTypes = propTypes;
PaymentsStatus.defaultProps = defaultProps;

export default PaymentsStatus;
